import { render } from "./AmalgamationHistory.vue?vue&type=template&id=e95175e8"
import script from "./AmalgamationHistory.vue?vue&type=script&lang=js"
export * from "./AmalgamationHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__